import { useEffect } from "react";
import Cookies from "js-cookie";

import { affiliateIdCookieName } from "helpers/constants";
import { useStoreActions } from "store/store";

export const useAffiliateId = () => {
  // actions
  const setAffiliateIdStore = useStoreActions((a) => a.setAffiliateId);
  const setAffiliateId = useStoreActions((a) => a.setAffiliateId);

  useEffect(() => {
    setAffiliateIdStore(Cookies.get(affiliateIdCookieName));
  }, []);

  useEffect(() => {
    // Preferred source: the sub-site plugin injects `window.sjd_affiliate_id`
    // after the /book-now/<id>/ rewrite rule matches. Falling back to
    // pathname parsing is brittle because it depends on WP's permalink
    // config (a rename or added prefix would break indexing by segment).
    const injected = (
      window as unknown as { sjd_affiliate_id?: number | string }
    ).sjd_affiliate_id;
    const injectedStr =
      typeof injected === "number"
        ? String(injected)
        : typeof injected === "string"
          ? injected.trim()
          : "";

    let affiliateIdFromPath = "";
    if (injectedStr && /^\d+$/.test(injectedStr)) {
      affiliateIdFromPath = injectedStr;
    } else {
      const pathname = window.location.pathname;
      const pathItems = pathname.split("/");
      affiliateIdFromPath = (pathItems[2] ?? "").replace("/", "");
    }

    const affiliateCookie = Cookies.get(affiliateIdCookieName);

    if (/^\d+$/.test(affiliateIdFromPath)) {
      setAffiliateIdStore(affiliateIdFromPath);
      Cookies.remove(affiliateIdCookieName);
      setAffiliateId(affiliateIdFromPath);
      Cookies.set(affiliateIdCookieName, affiliateIdFromPath ?? "", {
        expires: 30,
      });
    } else if (affiliateCookie) {
      const affiliateIdCookie = Cookies.get(affiliateIdCookieName);
      setAffiliateId(affiliateIdCookie);
    }
  }, [setAffiliateId]);
};
